import actions from './actions';

const initialState = {
    cajas: [],
    cuentas: [],
    movimientos: [],
    loading: false,
    cierres: [],
    saldos: [],
    paginationCajasInfo: {
        currentPage: 1,
        totalPages: 1,
        pageSize: 10,
    },
    paginationCuentasInfo: {
        currentPage: 1,
        totalPages: 1,
        pageSize: 10,
    },
    paginationMovimientosInfo: {
        currentPage: 1,
        totalPages: 1,
        pageSize: 10,
    },
};

export default function contabilidadReducer(state = initialState, action) {
    switch (action.type) {
        //cuentas
        case actions.GET_CUENTAS_REQUEST:
        case actions.GET_CIERRES_REQUEST:
        case actions.GET_SALDOS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case actions.GET_CUENTAS_SUCCESS:
            return {
                ...state,
                cuentas: action.payload,
                loading: false,
            };
        case actions.CREATE_CUENTA_SUCCESS:
            return {
                ...state,
                cuentas: [...state.cuentas, action.payload],
                loading: false,
            };

        case actions.EDIT_CUENTA_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case actions.EDIT_CUENTA_SUCCESS:
            return {
                ...state,
                cuentas: state.cuentas.map(cuenta => cuenta._id === action.payload.data._id ? action.payload.data : cuenta),
                loading: false,
            };
        // cajas
        case actions.GET_CAJAS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case actions.GET_CAJAS_SUCCESS:
            return {
                ...state,
                cajas: action.payload,
                loading: false,
            };
        case actions.EDIT_CAJA_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case actions.EDIT_CAJA_SUCCESS:
            return {
                ...state,
                cajas: state.cajas.map(caja => caja._id === action.payload._id ? action.payload : caja),
                loading: false,
            };
        // movimientos
        case actions.GET_MOVIMIENTOS_REQUEST:
            return {
                ...state,
                saldos: [],
                cierres: [],
                movimientos: [],
                loading: true,
            };
        case actions.GET_MOVIMIENTOS_SUCCESS:
            return {
                ...state,
                movimientos: action.payload,
                loading: false,
            };
        case actions.GET_MOVIMIENTOS_INFORMES_REQUEST:
            return {
                ...state,
                saldos: [],
                cierres: [],
                movimientos: [],
                loading: true,
            };
        case actions.GET_MOVIMIENTOS_INFORMES_SUCCESS:
            return {
                ...state,
                movimientos: action.payload.movimientos,
                cierres: action.payload.cierres,
                saldos: action.payload.saldos,
                loading: false,
            };
        case actions.EDIT_MOVIMIENTO_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case actions.EDIT_MOVIMIENTO_SUCCESS:
            return {
                ...state,
                movimientos: state.movimientos.map(movimiento => movimiento._id === action.payload._id ? action.payload : movimiento),
                loading: false,
            };
        case actions.GET_CIERRES_SUCCESS:
            return {
                ...state,
                cierres: action.payload,
                loading: false,
            };
        case actions.GET_SALDOS_SUCCESS:
            return {
                ...state,
                saldos: action.payload,
                loading: false,
            };
        default:
            return state;
    }

}
